import { makeStyles, tokens } from '@fluentui/react-components';

export const useNewCustomerMessageDialogStyles = makeStyles({
    dialogSurface: {
        maxWidth: '600px',
        maxHeight: '90vh',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        width: '100%',
        padding: '20px',
        overflowY: 'auto',
    },
    field: {
        width: '100%',
    },
    sectionTitle: {
        marginBottom: '8px',
        color: tokens.colorBrandForeground1,
    },
    customerForm: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '16px',
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
    },
    duplicateWarning: {
        marginTop: '4px',
        marginBottom: '8px',
    },
    formActions: {
        display: 'flex',
        gap: '8px',
        marginTop: '8px',
    },
    addCustomerButton: {
        alignSelf: 'flex-start',
        marginTop: '8px',
    },
    customerList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    emptyCustomerList: {
        padding: '16px',
        textAlign: 'center',
        color: tokens.colorNeutralForeground3,
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
    },
    customerListTitle: {
        marginBottom: '4px',
    },
    customerListItems: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxHeight: '300px',
        overflowY: 'auto',
        padding: '4px',
    },
    customerCard: {
        width: '100%',
        flex: '1 0 auto',
    },
    customerActions: {
        display: 'flex',
        gap: '4px',
    },
    messageSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '16px',
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
    },
    confirmationView: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    confirmationSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    confirmationLabel: {
        color: tokens.colorBrandForeground1,
        fontSize: tokens.fontSizeBase300,
    },
    confirmationCustomerList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxHeight: '250px',
        overflowY: 'auto',
        padding: '4px',
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
    },
    confirmationCustomerCard: {
        width: '100%',
    },
    confirmationMessageCard: {
        padding: '12px',
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
});
